module.exports = __webpack_public_path__ + "img/cloud.6c5be50f.svg";